/* unplugin-vue-components disabled */import { render } from "./loading.vue?vue&type=template&id=652dc36f&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=652dc36f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652dc36f"]])

export default __exports__